module.exports = __webpack_public_path__ + "img/logo_quac_morado.39394ab3.svg";